import { Container, Row, Col } from "react-bootstrap";

export const Footer = () => {
  const url = [
    "https://www.facebook.com/elliot.anderson.79230/",
    "https://github.com/Brandzess123",
    "https://www.linkedin.com/in/hieu-dang-3889901a4/",
  ];

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <div className="footer-brand">
              <span className="footer-mark">Hieu Dang</span>
              <h3>Frontend developer shaping cinematic interfaces with Arcane energy.</h3>
              <p>Built for product storytelling, interaction polish, and a darker Piltover x Zaun atmosphere.</p>
            </div>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href={url[0]} target="_blank" rel="noopener noreferrer">
                <img
                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg"
                  alt="Facebook"
                  style={{ width: "15px" }}
                />
              </a>

              <a href={url[1]} target="_blank" rel="noopener noreferrer">
                <img
                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/github.svg"
                  alt="GitHub"
                  style={{ width: "15px" }}
                />
              </a>

              <a href={url[2]} target="_blank" rel="noopener noreferrer">
                <img
                  src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/linkedin.svg"
                  alt="LinkedIn"
                  style={{ width: "15px" }}
                />
              </a>
            </div>
            <p>Based in Vietnam // Available for portfolio, landing page, and product UI work.</p>
            <a
              href="https://www.dmca.com/Protection/Status.aspx?ID=7b198cbd-4def-4405-9689-f8f35e0ae696"
              title="DMCA.com Protection Status"
              className="dmca-badge"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://images.dmca.com/Badges/dmca_protected_sml_120l.png?ID=7b198cbd-4def-4405-9689-f8f35e0ae696"
                alt="DMCA.com Protection Status"
              />
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
